<template>
	<form
		@submit.prevent="submitLookup()"
		class="space-y-6">
		<tw-input
			v-model="accountNumber"
			id="accountNumber"
			name="accountNumber"
			:required="true"
			type="text"
			autocomplete="off"
			label="Account Number"
			placeholder="12345"
			validation="Please enter your account number." />

		<tw-input
			v-model="invoiceNumber"
			id="invoiceNumber"
			name="invoiceNumber"
			:required="true"
			type="text"
			autocomplete="off"
			label="Invoice Number"
			placeholder="67890"
			validation="Please enter your invoice number." />

		<!-- honeypot: zero size and clipped so it can never affect layout, left for bots to fill in -->
		<div
			class="absolute -left-[9999px] top-0 h-0 w-0 overflow-hidden"
			aria-hidden="true">
			<label
				for="website"
				class="sr-only">Leave this field blank</label>
			<input
				v-model="honeypot"
				type="text"
				id="website"
				name="website"
				tabindex="-1"
				autocomplete="off">
		</div>

		<div>
			<div
				v-if="message"
				class="text-red-600 w-full justify-center text-sm font-bold pb-4 items-end flex dark:text-red-500">
				{{ message }}
			</div>

			<div class="pt-4">
				<tw-button
					type="submit"
					class="btn-db-yellow w-full"
					:disabled="loading"
					:loading="loading">
					Find Invoice
				</tw-button>
			</div>
		</div>
	</form>
</template>

<script lang="ts">
	export default { name: 'InvoiceLookupForm' } // name the component
</script>

<script setup lang="ts">
	// vue
	import {
		ref
	} from 'vue'

	defineProps({
		loading: {
			type: Boolean,
			default: false
		},
		message: {
			type: String,
			default: ''
		}
	})

	const emit = defineEmits([
		'submit'
	])

	const invoiceNumber = ref("")
	const accountNumber = ref("")
	const honeypot = ref("")

	// hands the entered values to the page, which owns the lookup itself
	function submitLookup() {
		if (accountNumber.value == "") {
			document.getElementById('accountNumber')?.focus()
			return
		}

		if (invoiceNumber.value == "") {
			document.getElementById('invoiceNumber')?.focus()
			return
		}

		emit('submit', {
			invoiceNumber: invoiceNumber.value,
			accountNumber: accountNumber.value,
			honeypot: honeypot.value
		})
	}
</script>
